module.exports = __webpack_public_path__ + "static/regnio_logo_white_text-45f92a6ceb7085dc3a967890cbda52b5.svg";